<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'طلبات أولياء الأمور'" :to="{name: 'parents'}">طلبات اولياء الامور</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">



                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                        إدارة طلبات أولياء الأمور
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">
                                          <create-button  v-if="hasPermissions('parents_create')" :routeName="'parents.create'"></create-button>
                                        </li>
<li>                               <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1" v-if="searchingMode == 0" @click="searchingMode = 1"><span>فلاتر البحث</span></button>
                                <button class="btn btn-danger search-btn-wg mb-2" v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>
                                      </ul>

                                      </div>
                                </div>


                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-4">
                                          <label for="">الاسم</label>
                                          <input type="text" v-model="data.searching.name" class="form-control" placeholder="الاسم">
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">رقم جوال ولى الامر</label>
                                          <input type="text" v-model="data.searching.mobile" class="form-control" placeholder="رقم جوال ولي الامر">
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">حالة الطالب</label>
                                          <select class="form-control" v-model="data.searching.status">
                                              <option value=""> الجميع</option>
                                              <option value="pending">معلق</option>
                                              <option value="canceled">مرفوض</option>
                                              <option value="accepted">مقبول</option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">المرحلة الدراسية </label>
                                          <treeselect :options="stages" v-model="data.searching.stage_id" @select="getGroupsByStage" :multiple="false"/>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">الصف </label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" :multiple="false"/>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">من تاريخ</label>
                                          <date-picker v-model="data.searching.from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">إلى تاريخ </label>
                                          <date-picker v-model="data.searching.to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4 mt-2">
                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                    <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                            <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">الاسم</th>
                                                <th @click="resortData();">رقم الجوال</th>
                                                <th @click="resortData();">المرحلة الدراسية</th>
                                                <th @click="resortData();">الصف</th>
                                                    <th @click="resortData();">تاريخ الطلب</th>
                                                <th @click="resortData();">حالة الطلب</th>

                                                <th class="align-center">#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in data.data" :key="index">
                                                <td>{{index+1}}</td>
                                                <td>{{item.name}}</td>
                                                <td>{{item.mobile}}</td>
                                                <td>{{item.stage ? item.stage.name : '---'}}</td>
                                                <td>{{item.group ? item.group.name : '---'}}</td>
                                                <td>{{item.request_date}}</td>
                                                <td>
                                                  <span class="badge badge-warning" v-if="item.status == 'pending'">معلق</span>
                                                  <span class="badge badge-danger" v-else-if="item.status == 'canceled'">مرفوض</span>
                                                  <span class="badge badge-success" v-else>مقبول</span>
                                                </td>
                                                <td class="text-center">

                                                    <div class="dropdown custom-dropdown">
                                                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i class="flaticon-dot-three fs-17"></i>
                                                        </a>

                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                            <router-link class="dropdown-item" href="javascript:void(0);" :to="{name: 'parents.show', params: {id: item.id}}">عرض</router-link>
                                                            <edit-button v-if="hasPermissions('parents_edit')" :routing="{name: 'parents.edit', params: {id: item.id}}"></edit-button>
                                                            <delete-button v-if="item.id != 1 &&  hasPermissions('parents_delete')" :deleteUrl="'/parents/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">الاسم</th>
                                                <th @click="resortData();">رقم الجوال</th>
                                                <th @click="resortData();">المرحلة الدراسية</th>
                                                <th @click="resortData();">الصف</th>
                                                  <th @click="resortData();">تاريخ الطلب</th>
                                                <th @click="resortData();">حالة الطلب</th>

                                                <th class="align-center">#</th>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import Treeselect from '@riophae/vue-treeselect'

import VueDatetimeJs from 'vue-datetime-js'
export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
       searchingMode: 0,
      groups: [],
      data: {
        data: {},
        searching:{
            id: '',
            name: '',
            mobile: '',
            from: '',
            to: '',
            group_id: '',
            stage_id: '',
            status: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      }
    };
  },
  created(){
    this.flashAlert();
      this.getGroups();
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    getGroups(){
        this.$baseApi.get('/parents?group=1').then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.options;
               this.stages = response.data.data.stages;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      getGroupsByStage(val){
        this.$baseApi.get('/parents?g=1&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.options;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      getIndexData(page){
        this.$baseApi.get('/parents?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
                  console.log(response.data.data)
            if(response.data.code == 200){
               this.data.paginated = response.data.data.users;
               this.data.data = response.data.data.users.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
